import VideoCallIcon from "@mui/icons-material/VideoCall";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Box, Chip, IconButton } from "@mui/material";

const AttachmentPreview = ({ attachments, onRemoveAttachment }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        mb: 2,
        p: 2,
        bgcolor: "rgba(255,255,255,0.1)",
        borderRadius: 1,
      }}
    >
      {attachments.map((att) => (
        <Box
          key={att.id}
          sx={{
            position: "relative",
            width: att.preview ? 100 : "auto",
            height: att.preview ? 100 : "auto",
          }}
        >
          {att.preview ? (
            <Box
              component="img"
              src={att.preview}
              alt={att.name}
              sx={{
                width: 100,
                height: 100,
                objectFit: "cover",
                borderRadius: 1,
              }}
            />
          ) : (
            <Chip
              icon={
                att.type.startsWith("video/") ? (
                  <VideoCallIcon />
                ) : (
                  <AttachFileIcon />
                )
              }
              label={att.name}
              variant="outlined"
              sx={{
                color: "white",
                borderColor: "rgba(255,255,255,0.3)",
                "& .MuiChip-icon": { color: "white" },
              }}
            />
          )}
          <IconButton
            size="small"
            sx={{
              position: "absolute",
              top: -8,
              right: -8,
              bgcolor: "rgba(0,0,0,0.5)",
              color: "white",
              "&:hover": { bgcolor: "rgba(255,0,0,0.7)" },
            }}
            onClick={() => onRemoveAttachment(att.id)}
          >
            ×
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default AttachmentPreview;
